import { SelectItem } from "primeng/api";
import { CriticalityLevel } from "../../../enum/criticality-level.enum";

  export const criticalityOptions: SelectItem[] = [
    { label: 'Critique', value: CriticalityLevel.Critical },
    { label: 'Élevée', value: CriticalityLevel.High },
    { label: 'Moyenne', value: CriticalityLevel.Medium },
    { label: 'Basse', value: CriticalityLevel.Low },
  ];